// 藥倉詳細內容

<template lang="pug">
  div
    div.row
      div.col-2
        div.form-group
          div.input-group
            div.input-group-prepend
              span.input-group-text 庫存
            input.form-control(
              type="number"
              min="0"
              v-model="Data.stock")
      div.col-2
        div.form-group
          div.input-group
            div.input-group-prepend
              span.input-group-text 最大庫存
            input.form-control(
              type="number"
              min="0"
              v-model="Data.max_stock")
      div.col-3
        div.form-group
          div.input-group
            div.input-group-prepend
              span.input-group-text 有效期限
            input.form-control(
              type="date"
              v-model="Data.expired_date")
      div.col-3
        div.form-group
          div.input-group
            div.input-group-prepend
              span.input-group-text 批號
            input.form-control(
              type="text"
              v-model="Data.patch_number")
      div.col-2
        div.action-button-group
          button.btn.btn-primary(@click="update") 更新
          button.btn.btn-danger(@click="del") 刪除
          Confirm(v-show="confirm" :message="'確定刪除?'" v-on:response="confirmDel")
</template>

<script>
import Confirm from '../../common/Confirm';

export default {
  name: 'ADCDrugDetail',
  data() {
    return {
      Data: null,
      confirm: false,
    };
  },
  components: {
    Confirm,
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
  },
  mounted() {
    this.Data = Object.assign({}, this.rowData);
    // this.Data = this.rowData;
  },
  methods: {
    update() {
      if (this.Data.max_stock >= this.Data.stock) {
        this.instance.put(`/api/drug-storage/${this.Data.id}/`, {
          id: this.Data.id,
          type: 'ADMIN_UPDATE',
          stock: this.Data.stock,
          device: this.Data.device.id,
          medication: this.Data.medication.id,
          max_stock: this.Data.max_stock,
          expired_date: this.Data.expired_date,
          patch_number: this.Data.patch_number,
          inventoried_in_tag_system: this.Data.inventoried_in_tag_system,
          number1: this.Data.stock - this.rowData.stock,
        })
        .then((res) => {
          this.$store.commit('SET_MESSAGE', { type: 'success', context: '更新成功' });
          this.$parent.refresh();
          console.log(this.$parent.$parent);
          this.$parent.$parent.$parent.refresh();
        })
        .catch((err) => {
          let context = '';
          if (err.response) {
            context = err.response.data;
          }
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context,
          });
        });
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '最大庫存不可小於庫存量',
        });
      }
    },
    confirmDel(response) {
      this.$store.commit('SET_MESSAGE', { type: 'warn', context: '刪除中', confirm: false });
      this.confirm = false;
      if (response) {
        this.instance.delete(`/api/drug-storage/${this.Data.id}/`, {
          data: {
            type: 'ADMIN_DELETE',
          },
        })
        .then(async (res) => {
          await this.$parent.refresh();
          await this.$parent.$parent.$parent.refresh();
          this.$store.commit('CLOSE_MESSAGE');
        });
      }
    },
    del() {
      this.confirm = true;
    },
  },
  watch: {
    Data: {
      deep: true,
      handler: (val, oldVal) => {
        console.log('data changed.');
        val.stock = parseInt(oldVal.stock, 10);
        val.max_stock = parseInt(oldVal.max_stock, 10);
      },
    },
  },
};
</script>

<style lang="sass" scoped>
.action-button-group
  display: flex;
  justify-content: flex-end;
  .btn
    &:first-child
      margin-right: 10px

.form-group
  margin: 0
</style>



// WEBPACK FOOTER //
// DrugDetail.vue?379d48ba